"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _iconBookmark = _interopRequireDefault(require("../../../../shared/icons/icon-bookmark.svg"));

var _PrismicHtmlSerializer = _interopRequireDefault(require("../../../../htmlSerializer/PrismicHtmlSerializer"));

var _helpers = _interopRequireDefault(require("../helpers"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var keyPointsListTypeConfig = {
  bookmarked: {
    ListType: 'ul',
    CounterType: _iconBookmark["default"],
    counterClassName: '__bookmark-icon',
    numberedCounter: false
  },
  numbered: {
    ListType: 'ol',
    CounterType: 'span',
    counterClassName: '__item-counter',
    numberedCounter: true
  }
};
/* eslint-disable camelcase */

var KeyPointsListItems = function KeyPointsListItemsComponent(_ref) {
  var sliceLabel = _ref.sliceLabel,
      dataClient = _ref.dataClient,
      keyPointsConfig = _ref.keyPointsConfig,
      items = _ref.items;
  var _keyPointsListTypeCon = keyPointsListTypeConfig[sliceLabel],
      ListType = _keyPointsListTypeCon.ListType,
      CounterType = _keyPointsListTypeCon.CounterType,
      counterClassName = _keyPointsListTypeCon.counterClassName,
      numberedCounter = _keyPointsListTypeCon.numberedCounter;
  var listTypeClassName = (0, _classnames["default"])('key-points-body-list', {
    'key-points-body-list--bookmark': sliceLabel === 'bookmarked',
    'key-points-body-list--numbered': sliceLabel === 'numbered'
  });
  return /*#__PURE__*/_react["default"].createElement(ListType, {
    className: listTypeClassName
  }, items.map(function (_ref2, idx) {
    var list_item_type = _ref2.list_item_type,
        key_point_title = _ref2.key_point_title,
        key_point_body = _ref2.key_point_body;
    var isContentBox = list_item_type === 'Content Box';
    var key = null;

    if (isContentBox) {
      key = "content-box-".concat(idx + 1);
    } else {
      key = dataClient.renderText(key_point_title);
    }

    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, {
      key: key
    }, isContentBox && /*#__PURE__*/_react["default"].createElement("div", {
      className: "key-points-body__content-box-wrapper"
    }, !(0, _helpers["default"])(key_point_title) && /*#__PURE__*/_react["default"].createElement("div", {
      className: "key-points-body__content-box-title"
    }, dataClient.textToMarkdown(key_point_title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "key-points-body__content-box-body"
    }, /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      content: key_point_body,
      baseClass: "key-points-body__content-box-body"
    }))), !isContentBox && /*#__PURE__*/_react["default"].createElement("li", {
      className: "key-points-body-list__item"
    }, /*#__PURE__*/_react["default"].createElement(CounterType, {
      className: "key-points-body-list".concat(counterClassName)
    }, numberedCounter && "".concat(idx + 1, ". ")), /*#__PURE__*/_react["default"].createElement("h3", {
      className: "key-points-body__heading-3"
    }, dataClient.textToMarkdown(key_point_title)), /*#__PURE__*/_react["default"].createElement(_PrismicHtmlSerializer["default"], {
      content: key_point_body,
      baseClass: "key-points-body",
      options: keyPointsConfig
    })));
  }));
};

KeyPointsListItems.propTypes = {
  sliceLabel: _propTypes["default"].string.isRequired,
  dataClient: _propTypes["default"].shape({
    slice_label: _propTypes["default"].string,
    items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    primary: _propTypes["default"].shape({
      background_color: _propTypes["default"].string,
      key_points_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
    })
  }).isRequired,
  keyPointsConfig: _propTypes["default"].shape({}).isRequired,
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    list_item_type: _propTypes["default"].string,
    key_point_title: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
    key_point_body: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
  })).isRequired
};
var _default = KeyPointsListItems;
exports["default"] = _default;